/** The same painting algorithms run on DOM canvases and worker-owned surfaces. */
export type RenderCanvas = HTMLCanvasElement | OffscreenCanvas;
export type RenderContext =
  CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D;
export type RenderImage =
  HTMLImageElement | HTMLCanvasElement | OffscreenCanvas | ImageBitmap;
export interface RenderImages {
  get(source: string): RenderImage | undefined;
  display?(
    source: string,
    width: number,
    height: number,
  ): RenderImage | undefined;
}
export function renderCanvas(): RenderCanvas {
  if (typeof document !== "undefined") return document.createElement("canvas");
  const surface = new OffscreenCanvas(1, 1);
  // Pixel effects read these surfaces repeatedly. Keep worker readbacks off the
  // shared GPU queue so refinement does not stall the visible canvas compositor.
  surface.getContext("2d", { willReadFrequently: true });
  return surface;
}
export function imageSize(image: RenderImage) {
  return "naturalWidth" in image
    ? { width: image.naturalWidth, height: image.naturalHeight }
    : { width: image.width, height: image.height };
}
